import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface OrderApproveIconProps extends SvgIconProps {}

export const OrderApproveIcon = (
  props: OrderApproveIconProps,
): ReactElement => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <mask
        id="mask0_1785_3001"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1785_3001)">
        <path
          d="M17.3712 19.827L20.2115 17.0307L19.5845 16.4038L17.3712 18.5865L16.4155 17.6115L15.7885 18.2443L17.3712 19.827ZM6.76925 8.73075H17.2308V7.73075H6.76925V8.73075ZM18 22.1155C16.8858 22.1155 15.9407 21.7273 15.1645 20.951C14.3882 20.1747 14 19.2295 14 18.1155C14 17.0013 14.3882 16.0561 15.1645 15.2797C15.9407 14.5036 16.8858 14.1155 18 14.1155C19.1142 14.1155 20.0593 14.5036 20.8355 15.2797C21.6118 16.0561 22 17.0013 22 18.1155C22 19.2295 21.6118 20.1747 20.8355 20.951C20.0593 21.7273 19.1142 22.1155 18 22.1155ZM4 20.7693V5.6155C4 5.168 4.15733 4.78683 4.472 4.472C4.78683 4.15733 5.168 4 5.6155 4H18.3845C18.832 4 19.2132 4.15733 19.528 4.472C19.8427 4.78683 20 5.168 20 5.6155V11.5595C19.8372 11.4993 19.6757 11.4481 19.5155 11.4058C19.3552 11.3634 19.1833 11.3301 19 11.3058V5.6155C19 5.4615 18.9359 5.32042 18.8077 5.19225C18.6796 5.06408 18.5385 5 18.3845 5H5.6155C5.4615 5 5.32042 5.06408 5.19225 5.19225C5.06408 5.32042 5 5.4615 5 5.6155V19.05H11.3442C11.3891 19.323 11.4477 19.5903 11.5202 19.852C11.5926 20.1135 11.6935 20.3628 11.823 20.6L11.7885 20.6345L10.6537 19.8077L9.30775 20.7693L7.9615 19.8077L6.6155 20.7693L5.26925 19.8077L4 20.7693ZM6.76925 16.2692H11.4787C11.5159 16.0859 11.5621 15.9141 11.6172 15.7537C11.6724 15.5936 11.7365 15.4321 11.8095 15.2692H6.76925V16.2692ZM6.76925 12.5H14.0807C14.4064 12.2423 14.7561 12.0273 15.1298 11.8548C15.5036 11.6824 15.9027 11.5642 16.327 11.5H6.76925V12.5Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};
